import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'
import { EFIconProps } from './IconProps'

export function DeviceIcon(propsIcon: EFIconProps) {
  const isDark = useAppSelector(isDarkTheme)
  return (
    <svg
      width='38'
      height='26'
      viewBox='0 0 38 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <mask
        id='mask0_11_11263'
        mask-type='alpha'
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='38'
        height='26'
      >
        <path
          d='M7.05373 3.48906H34.5196V0.326538H7.05373C5.37526 0.326538 4.00196 1.74967 4.00196 3.48906V20.8829H0.950195V25.6267H22.3126V20.8829H7.05373V3.48906ZM36.0455 6.65157H26.8902C26.051 6.65157 25.3643 7.36314 25.3643 8.23283V24.0454C25.3643 24.9151 26.051 25.6267 26.8902 25.6267H36.0455C36.8848 25.6267 37.5714 24.9151 37.5714 24.0454V8.23283C37.5714 7.36314 36.8848 6.65157 36.0455 6.65157ZM34.5196 20.8829H28.4161V9.81409H34.5196V20.8829Z'
          fill='black'
        />
      </mask>
      <g mask='url(#mask0_11_11263)'>
        <path
          d='M-9.32623 -12.2322H51.113V28.8197H-9.32623V-12.2322Z'
          fill={isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'}
        />
      </g>
    </svg>
  )
}
